export const SCROLL_DELAY_ANIMATED = 460;
export const SCROLL_DELAY_INSTANT = 50;

/** Wait after widget scroll so accordion height transitions finish before iframe scrollIntoView (open-one-at-a-time). */
export const SCROLL_INTO_VIEW_AFTER_TRANSITION_MS = 340;

export const scrollToElement = (
  itemId: string,
  delay: number = 300,
  scrollFn?: (id: string) => void,
): void => {
  setTimeout(() => {
    const element = document.getElementById(itemId);
    if (!element) {
      return;
    }
    // External handler (e.g. host-page scroll via appAPI) must always run —
    // getBoundingClientRect uses local/iframe coordinates and cannot reliably
    // determine whether the widget is in view in the host page.
    if (scrollFn) {
      scrollFn(itemId);
      return;
    }
    // Native fallback: only scroll when the header is not already well-positioned.
    // Skip if header is in the upper 65 % of the viewport (content below is reachable);
    // scroll for above-viewport, below-viewport, or lower-35 % (expanded content cut off).
    const rect = element.getBoundingClientRect();
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;
    const isHeaderInGoodPosition =
      rect.top >= 0 && rect.top < viewportHeight * 0.65;
    if (
      !isHeaderInGoodPosition &&
      typeof element.scrollIntoView === 'function'
    ) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, delay);
};
